import React, { Component } from "react";
import UserForm from "./components/UserForm";
import CompanyForm from "./components/CompanyForm";
import { Props, State } from "./Types";
import { getVatTypes } from "./helpers";
import SpecialOptions from "../CheckoutForm/components/SpecialOptions";

class BillingInfo extends Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      isComplete: false,
      showCompanyForm: false,
      type: "user",
      userDetails: {
        name: "",
        email: "",
        address: "",
        city: "",
        postalCode: "",
        country: "",
      },
      companyDetails: {
        name: "",
        email: "",
        billingName: "",
        address: "",
        city: "",
        postalCode: "",
        vatNumber: "",
        vatType: "",
        country: "",
      },
      vatTypes: [],
    };
  }

  componentDidMount() {
    this.setState({
      userDetails: this.props.userDetails,
      companyDetails: this.props.companyDetails,
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.country !== prevProps.country) {
      this.setState({
        userDetails: this.props.userDetails,
        companyDetails: this.props.companyDetails,
      });
    }
  }

  onChangeType = (e, type) => {
    e.preventDefault();

    this.setState({ type });
    this.props.handleChange("billingType", type);
  };

  // Closing the company invoice fields makes it a personal purchase again,
  // even with something typed in them; opening them brings that back.
  onChangeShowCompanyForm = (e) => {
    const showCompanyForm = !this.state.showCompanyForm;

    this.setState({ showCompanyForm });

    if (showCompanyForm) {
      this.props.handleChange("companyDetails", this.state.companyDetails);
    } else {
      this.props.handleChange("billingType", "user");
    }
  };

  updateUserDetails = (key, value) => {
    const { userDetails } = this.state;

    const updatedUserDetails = { ...userDetails, [key]: value };

    this.setState({ userDetails: updatedUserDetails });
    this.props.handleChange("userDetails", updatedUserDetails);
  };

  updateCompanyDetails = (key, value) => {
    let { companyDetails } = this.state;

    const updatedCompanyDetails = {
      ...companyDetails,
      [key]: value,
    };

    this.setState({ companyDetails: updatedCompanyDetails });

    this.props.handleChange("companyDetails", updatedCompanyDetails);
  };

  updateCompanyCountryDetails = (key, value) => {
    let { companyDetails } = this.state;

    const vatTypes = getVatTypes(value);

    const updatedCompanyDetails = {
      ...companyDetails,
      [key]: value,
      vatType: vatTypes[0]?.value,
    };

    this.setState({ companyDetails: updatedCompanyDetails, vatTypes });

    this.props.handleChange("companyDetails", updatedCompanyDetails);

    // The main form's country goes into the company details too, which
    // must not make it a company purchase again while those are closed.
    if (!this.state.showCompanyForm) {
      this.props.handleChange("billingType", "user");
    }
  };

  render() {
    const {
      countries,
      country,
      isCurrentUserPresent,
      paymentType,
      priceable,
      selectedCourse,
      slug,
    } = this.props;
    const { showCompanyForm, userDetails, companyDetails, vatTypes } =
      this.state;
    const isLifetimeCheckout = slug === "lifetime" || priceable?.is_lifetime;

    return (
      <>
        <div className="special-options" id="specialOptions">
          <SpecialOptions
            giftLink={
              paymentType === "gift" || isLifetimeCheckout
                ? null
                : paymentType === "course"
                ? `/courses/${selectedCourse}/gift`
                : "/passes/year/gift"
            }
            showCompanyForm={showCompanyForm}
            onChangeShowCompanyForm={this.onChangeShowCompanyForm}
          />
          {showCompanyForm && (
            <CompanyForm
              isCurrentUserPresent={isCurrentUserPresent}
              userDetails={userDetails}
              companyDetails={companyDetails}
              vatTypes={vatTypes}
              updateUserDetails={this.updateUserDetails}
              updateCompanyDetails={this.updateCompanyDetails}
              updateCompanyCountryDetails={this.updateCompanyCountryDetails}
              countries={countries}
            />
          )}
        </div>
        <UserForm
          isCurrentUserPresent={isCurrentUserPresent}
          userDetails={userDetails}
          countries={countries}
          updateUserDetails={this.updateUserDetails}
          updateCompanyCountryDetails={this.updateCompanyCountryDetails}
        />
      </>
    );
  }
}

export default BillingInfo;
